import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../_metronic/layout/core'
import {KTSVG} from '../../../../_metronic/helpers'
import {InputDefault, TableDefault} from '../../../components/ui'
import FilterMenu from '../../../components/sections/FilterMenu'
import {deleteRewardsById, getListRewards, Filter} from '../../../modules/services/rewards.service'
import {getBreadCrumbs} from '../breadcrumbs'
import {filtersMock} from '../../../mocks'

const RewardsCatalogPage = () => {
  const queryClient = useQueryClient()
  const headFields = ['ID', 'Reward', 'Available Voucher', 'Type']
  const bodyFields = ['id', 'attributes.name', 'attributes.stock', 'attributes.type']
  const [filter, setFilter] = useState<Filter>({field: null, type: null})
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(['getListRewardsDetail', search, filter, page], async () =>
    getListRewards(search, filter, page)
  )
  const datas: any = data?.data
  const pageCount = data?.meta?.pagination.pageCount

  const handleDelete = (id: any) => {
    mutate(id)
  }

  const {mutate, isLoading: loading} = useMutation((id) => deleteRewardsById(id), {
    onSuccess: async () => {
      toast.success('Delete Data Succes')
      await queryClient.invalidateQueries('getListRewardsDetail')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Rewards List</p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <Link to={'/rewards-catalog/create'}>
                <button className='btn btn-primary' data-bs-target='#add-edit-member'>
                  Add
                </button>
              </Link>
            </div>
            <div className='d-flex flex-row gap-4'>
              <InputDefault
                placeholder='Search'
                left={<i className='bi bi-search' />}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <button
                type='button'
                className='btn btn-light-primary d-flex'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
              >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
              </button>
              <FilterMenu filters={filtersMock.reward} filterState={[filter, setFilter]} />
            </div>
          </div>
        </div>
        {!isLoading && (
          <TableDefault
            head={headFields}
            body={bodyFields}
            data={datas}
            href={'rewards-catalog'}
            handleDelete={handleDelete}
            showEdit={true}
            allPaginate={pageCount}
            page={page}
            setsPage={setPage}
            nextPage={nextPage}
            prevPage={prevPage}
            loadings={loading}
            texts={'Apakah anda yakin ingin menghapus rewards ini'}
          />
        )}
      </div>
    </>
  )
}

const RewardsCatalogWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('loyalty-point/rewards-catalog')}>
        {intl.formatMessage({id: 'MENU.REWARDS_CATALOG'})}
      </PageTitle>
      <RewardsCatalogPage />
    </>
  )
}

export default RewardsCatalogWrapper
